import React, { useEffect, useState } from "react";
import { getWithTokenAPI } from "../../utils/Api";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
  CircularProgress,
  Box,
  Typography,
  Avatar,
  Chip,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Grid,
  Paper,
  IconButton,
  Divider,
  colors,
  Pagination,
} from "@mui/material";
import {
  Visibility as VisibilityIcon,
  Chat as ChatIcon,
  Person as PersonIcon,
  Email as EmailIcon,
  Subject as SubjectIcon,
  Message as MessageIcon,
  PriceChange,
} from "@mui/icons-material";
import CloseIcon from "@mui/icons-material/Close";

const ContactPage = () => {
  const [contactData, setContactData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedContactDetails, setSelectedContactDetails] = useState(null);
  const [openDialog, setOpenDialog] = useState(false);

  // Pagination states
  const [currentPage, setCurrentPage] = useState(1);
  const [enquiriesPerPage] = useState(10);

  // Colors
  const primaryGreen = "#DC3545";
  const lightGreen = "#ffe5e5";
  const darkGreen = "#b02a37";
  const secondaryTextColor = colors.grey[700]; // Assuming you have a secondaryTextColor in your user table context, using Material-UI's grey for consistency

  // Fetch all contact messages
  const fetchContactMessages = async () => {
    const token = localStorage.getItem("token");
    setLoading(true);
    try {
      const res = await getWithTokenAPI(token, "/contact/find-all");

      if (res.statusCode === 200) {
        console.log("API Response (full):", res);
        console.log("Number of contacts received:", res.data.contacts?.length);
        setContactData(res.data.contacts || []);
      } else {
        toast.error(res.message || "Failed to load contact messages.");
        setContactData([]);
      }
    } catch (error) {
      console.error("Fetch contact messages error:", error);
      toast.error("Failed to load contact messages due to a network error.");
      setContactData([]);
    } finally {
      setLoading(false);
    }
  };

  // Pagination logic
  const indexOfLastEnquiry = currentPage * enquiriesPerPage;
  const indexOfFirstEnquiry = indexOfLastEnquiry - enquiriesPerPage;
  const currentEnquiries = contactData.slice(
    indexOfFirstEnquiry,
    indexOfLastEnquiry
  );
  const totalPages = Math.ceil(contactData.length / enquiriesPerPage);

  const handlePageChange = (event, value) => {
    setCurrentPage(value);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  // Handle viewing a particular contact's details (when eye icon is clicked)
  const handleViewContact = async (contactId) => {
    const token = localStorage.getItem("token");
    setLoading(true);
    try {
      const res = await getWithTokenAPI(
        token,
        `/contact/find-particular?_id=${contactId}`
      );
      if (res.statusCode === 200) {
        setSelectedContactDetails(res.data);
        setOpenDialog(true);
      } else {
        toast.error(res.message || "Failed to load contact details.");
      }
    } catch (error) {
      console.error("Fetch particular contact error:", error);
      toast.error("Failed to load contact details due to a network error.");
    } finally {
      setLoading(false);
    }
  };

  // Close the dialog
  const handleCloseDialog = () => {
    setOpenDialog(false);
    setSelectedContactDetails(null);
  };

  // Initial data fetch on component mount
  useEffect(() => {
    fetchContactMessages();
  }, []);

  return (
    <Box sx={{ p: 3, width: "100%" }}>
      <ToastContainer position="top-center" autoClose={1500} />

      {/* Header */}
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          mb: 3,
          p: 2,
          backgroundColor: lightGreen,
          borderRadius: 2,
          borderLeft: `5px solid ${primaryGreen}`,
        }}
      >
        <ChatIcon sx={{ color: primaryGreen, fontSize: 40, mr: 2 }} />
        <Box>
          <Typography
            variant="h4"
            component="h1"
            sx={{ color: primaryGreen, fontWeight: "bold" }}
          >
            Enquiry
          </Typography>
          <Typography variant="body1" sx={{ color: "text.secondary" }}>
            View user contact enquiries
          </Typography>
        </Box>
      </Box>

      {/* Main Content - Table */}
      <div className="table-container border rounded">
        <div className="table-responsive">
          {loading ? (
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: "200px",
              }}
            >
              <CircularProgress style={{ color: primaryGreen }} />
              <Typography sx={{ ml: 2, color: primaryGreen }}>Loading contact messages...</Typography>
            </Box>
          ) : contactData.length > 0 ? (
            <>
              <table className="table m-0 resource-head">
                <thead
                  className="sticky-header fs-6"
                  style={{ backgroundColor: lightGreen }}
                >
                  <tr>
                    <th
                      className="table-header"
                      style={{ color: secondaryTextColor, textAlign: "left" }}
                    >
                      S.No
                    </th>
                    <th
                      className="table-header"
                      style={{ color: secondaryTextColor, textAlign: "left" }}
                    >
                      Name
                    </th>
                    <th
                      className="table-header"
                      style={{ color: secondaryTextColor, textAlign: "left" }}
                    >
                      Email
                    </th>
                    <th
                      className="table-header"
                      style={{ color: secondaryTextColor, textAlign: "left" }}
                    >
                      Subject
                    </th>
                    {/* <th
                      className="table-header"
                      style={{ color: secondaryTextColor, textAlign: "left" }}
                    >
                      Status
                    </th> */}
                    <th
                      className="table-header"
                      style={{ color: secondaryTextColor, textAlign: "left" }}
                    >
                      Actions
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {currentEnquiries.map((item, index) => (
                    <tr key={item._id}>
                      <td style={{ textAlign: "left" }}>
                        {indexOfFirstEnquiry + index + 1}
                      </td>
                      <td style={{ textAlign: "left" }}>
                        <Box sx={{ display: "flex", alignItems: "center" }}>
                          <Avatar
                            sx={{ width: 32, height: 32, mr: 1, bgcolor: primaryGreen }}
                          >
                            {item.name?.charAt(0) || "U"}
                          </Avatar>
                          <Typography variant="body2"       sx={{ 
        fontWeight: "bold",
        color: primaryGreen,
        textDecoration: "none",
        cursor: "pointer",

      }}
      onClick={() => handleViewContact(item._id)}
                          
                          
                          >
                            {item.name || "N/A"}
                          </Typography>
                        </Box>
                      </td>
                      <td style={{ textAlign: "left" }}>{item.email || "N/A"}</td>
                      <td style={{ textAlign: "left" }}>{item.subject || "N/A"}</td>
                      {/* <td style={{ textAlign: "left" }}>
                        <Chip
                          label={item.status || "N/A"}
                          size="small"
                          sx={{
                            backgroundColor:
                              item.status === "Active" ? lightGreen : "#fff3e0",
                            color: item.status === "Active" ? darkGreen : "#e65100",
                          }}
                        />
                      </td> */}
                      <td style={{ textAlign: "left" }}>
                        <IconButton
                          onClick={() => handleViewContact(item._id)}
                          sx={{ color: primaryGreen }}
                        >
                          <VisibilityIcon />
                        </IconButton>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
              {/* Pagination Controls */}
              {totalPages > 1 && (
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "end",
                    mt: 3,
                    pb: 2,
                  }}
                >
                  <Pagination
                    count={totalPages}
                    page={currentPage}
                    onChange={handlePageChange}
                    color="primary"
                    sx={{
                      "& .MuiPaginationItem-root": {
                        color: primaryGreen,
                      },
                      "& .MuiPaginationItem-root.Mui-selected": {
                        backgroundColor: primaryGreen,
                        color: "white",
                      },
                    }}
                  />
                </Box>
              )}
            </>
          ) : (
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                p: 4,
                textAlign: "center",
              }}
            >
              <ChatIcon sx={{ fontSize: 60, color: "text.disabled", mb: 2 }} />
              <Typography variant="h6" sx={{ mb: 1, color: "text.disabled" }}>
                No enquiries found
              </Typography>
            </Box>
          )}
        </div>
      </div>

      {/* Contact Details Dialog */}
      <Dialog open={openDialog} onClose={handleCloseDialog} maxWidth="sm" fullWidth>
        {selectedContactDetails && (
          <>
            <DialogTitle
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                backgroundColor: primaryGreen,
                color: "white",
              }}
            >
              <Typography
                variant="h6"
                sx={{ fontWeight: "bold", display: "flex", alignItems: "center" }}
              >
                <PersonIcon sx={{ mr: 1 }} /> Contact Details
              </Typography>
              <IconButton
                aria-label="close"
                onClick={handleCloseDialog}
                sx={{ color: "white" }}
              >
                <CloseIcon />
              </IconButton>
            </DialogTitle>
            <Divider />
            <DialogContent dividers sx={{ p: 3 }}>
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
                    <Avatar
                      sx={{ width: 60, height: 60, mr: 2, bgcolor: primaryGreen }}
                    >
                      {selectedContactDetails.name?.charAt(0) || "U"}
                    </Avatar>
                    <Box>
                      <Typography variant="h6" sx={{ fontWeight: "bold", color: darkGreen }}>
                        {selectedContactDetails.name || "N/A"}
                      </Typography>
                    </Box>
                  </Box>
                </Grid>
                <Grid item xs={12}>
                  <Paper elevation={0} sx={{ p: 2, border: `1px solid ${lightGreen}`, borderRadius: 2 }}>
                    <Box sx={{ display: "flex", alignItems: "center", mb: 1 }}>
                      <EmailIcon sx={{ color: darkGreen, mr: 1 }} />
                      <Typography variant="body2">
                        <span style={{ fontWeight: "bold" }}>Email:</span>{" "}
                        {selectedContactDetails.email || "N/A"}
                      </Typography>
                    </Box>
                    <Box sx={{ display: "flex", alignItems: "center", mb: 1 }}>
                      <SubjectIcon sx={{ color: darkGreen, mr: 1 }} />
                      <Typography variant="body2">
                        <span style={{ fontWeight: "bold" }}>Subject:</span>{" "}
                        {selectedContactDetails.subject || "N/A"}
                      </Typography>
                    </Box>
                    <Box sx={{ display: "flex", alignItems: "flex-start" }}>
                      <MessageIcon sx={{ color: darkGreen, mr: 1, mt: 0.5 }} />
                      <Typography variant="body2">
                        <span style={{ fontWeight: "bold" }}>Message:</span>{" "}
                        {selectedContactDetails.message || "N/A"}
                      </Typography>
                    </Box>
                    {/* <Box sx={{ display: "flex", alignItems: "center", mt: 1 }}>
                      <Typography variant="body2">
                        <span style={{ fontWeight: "bold" }}>Status:</span>{" "}
                        <Chip
                          label={selectedContactDetails.status || "N/A"}
                          size="small"
                          sx={{
                            backgroundColor:
                              selectedContactDetails.status === "Active" ? lightGreen : "#fff3e0",
                            color: selectedContactDetails.status === "Active" ? darkGreen : "#e65100",
                          }}
                        />
                      </Typography>
                    </Box> */}
                  </Paper>
                </Grid>
              </Grid>
            </DialogContent>
            <DialogActions sx={{ p: 2 }}>
              <Button
                onClick={handleCloseDialog}
                variant="outlined"
                sx={{ color: darkGreen, borderColor: darkGreen }}
              >
                Close
              </Button>
            </DialogActions>
          </>
        )}
      </Dialog>
    </Box>
  );
};

export default ContactPage;